<template>
  <div
    v-for="file in files"
    :key="file.id"
    class="mt-4 flex items-center justify-between rounded-sm border p-2"
  >
    <documents-list-item-name :model="file" />
    <div class="flex items-center">
      <p class="mr-20">{{ formatDate(file.updated_at || "") }}</p>
      <div class="flex items-center">
        <p class="mr-6">{{ formatDocumentListFileSize(file.file_size) }}</p>
        <span
          v-if="!deleteBtn"
          class="group cursor-pointer"
          @click.prevent="download(file)"
        >
          <icon-base
            :icon="IconDownload"
            class="opacity-50 group-hover:opacity-100"
          />
        </span>
        <span
          v-else
          class="group cursor-pointer"
          @click.prevent="handleDeleteClick(file)"
        >
          <icon-base :icon="IconX" class="opacity-50 group-hover:opacity-100" />
        </span>
      </div>
    </div>
  </div>
  <p v-if="!files.length" class="mt-4">{{ $t("COMMON.NO_FILES_ADDED") }}</p>
</template>
<script setup lang="ts">
import { useStore } from "vuex";

import { downloadFile } from "@/helpers/files";
import { formatDate, formatDocumentListFileSize } from "@/helpers/formatting";

import DocumentsListItemName from "@/components/deals/documents/DocumentsListItemName.vue";
import IconDownload from "@/components/icons/IconDownload.vue";
import IconX from "@/components/icons/deals/IconX.vue";

import type { IFile } from "@/models/common";
import type { PropType } from "vue";

defineProps({
  files: {
    type: Array as PropType<IFile[]>,
    required: true,
  },
  deleteBtn: {
    type: Boolean,
    default: false,
  },
});

const { dispatch } = useStore();

const download = (file: IFile) =>
  downloadFile(file.file_url, {}, file.original_name);

const handleDeleteClick = async (file: IFile) => {
  await dispatch("applications/deleteFile", {
    id: file.id,
  });
};
</script>
